module.exports = __webpack_public_path__ + "img/page-not-working.964b3e54.svg";